const AUTH_TOKEN_KEY = "te_auth_token";

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);

const isLocalHost = (): boolean => {
  return LOCAL_HOSTS.has(window.location.hostname.toLowerCase());
};

const getCookieDomain = (): string | null => {
  if (isLocalHost()) {
    return null;
  }

  const baseDomain =
    import.meta.env.VITE_BASE_DOMAIN ?? "tercerespacio.com.ar";

  return `.${baseDomain}`;
};

const readCookie = (name: string): string | null => {
  const prefix = `${name}=`;
  const match = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(prefix));

  if (!match) {
    return null;
  }

  return decodeURIComponent(match.slice(prefix.length));
};

const writeCookie = (name: string, value: string, maxAgeSeconds: number): void => {
  const domain = getCookieDomain();
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  const domainPart = domain ? `; Domain=${domain}` : "";

  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${secure}${domainPart}`;
};

const deleteCookie = (name: string): void => {
  const domain = getCookieDomain();
  const domainPart = domain ? `; Domain=${domain}` : "";

  document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax${domainPart}`;
};

/**
 * Persists JWT access token in localStorage and shared cookie (prod only)
 */
export const setAuthToken = (token: string): void => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);

  const cookieDomain = getCookieDomain();
  if (cookieDomain) {
    writeCookie(AUTH_TOKEN_KEY, token, 60 * 60 * 24);
  }
};

/**
 * Retrieves stored JWT access token (cookie first, then localStorage)
 */
export const getAuthToken = (): string | null => {
  return readCookie(AUTH_TOKEN_KEY) ?? localStorage.getItem(AUTH_TOKEN_KEY);
};

/**
 * Removes stored JWT access token
 */
export const clearAuthToken = (): void => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  deleteCookie(AUTH_TOKEN_KEY);
};
